import Vue from "vue";

Vue.component("good-basic-info-editor", {
	props: ["useModal", "party", "contextId"],
    data() {
        return {
            loading: false,
            id: 0,
            showModal: false,
            editorContextId: '0|0|0',
            counter: 0,
            currentId: this.contextId,
            partyCode: this.party,
            referenceNumber: '',            
            annexNumbers: [],
            displayOrder: 0,
            definesSymbol: null,
            excluded: false,
            textEn: null,
            textEs: null,
            textFr: null,
            currentLanguage: window.currentLanguage,
            classificationSystem: null,
            reviseClassificationSystem: false,
            retrievedClassificationSystem: null,
            retrievedInclusionClassificationSystemInfos: [],
            retrievedExclusionClassificationSystemInfos: [],
            inclusionClassificationSystemInfos: [],
            exclusionClassificationSystemInfos: [],
            activeTab: 0,
			language: 'en',
			languages: {
				'en': 'EN',
				'fr': 'FR',
				'es': 'ES'
            },
            reviseMetadata: false,
            numberings: [],
            numbering: null,
            numberingLabel: '',
            noteCode1997s: [],
            noteCode1997: null,
            noteCode1997Label: '',
            noteCodeGPA113s: [],
            noteCodeGPA113: null,
            noteCodeGPA113Label: '',
            furtherCharacterizations: [],
            furtherCharacterization: null,
            furtherCharacterizationLabel: ''
        };
    },
    methods: {
        initialize(goodId) {
            const self = this;

            self.id = goodId;
            self.loading = true;

            self.$services.goods.getById({
                id: goodId,
                language: window.currentLanguage,
                partyId: self.partyCode
            }).then((data) => {
                self.id = data.id;
                self.referenceNumber = data.referenceNumber;
                self.excluded = data.excluded;
                self.definesSymbol = data.definesSymbol;
                self.textEn = data.textEn;
                self.textEs = data.textEs;
                self.textFr = data.textFr;
                self.displayOrder = data.displayOrder;
                self.retrievedClassificationSystem = data.classificationSystem;
                self.retrievedInclusionClassificationSystemInfos = data.inclusionClassificationSystemInfos;
                self.retrievedExclusionClassificationSystemInfos = data.exclusionClassificationSystemInfos;               
                self.classificationSystem = null;
                self.inclusionClassificationSystemInfos = [];
                self.exclusionClassificationSystemInfos = [];
                self.reviseClassificationSystem = false;
                self.reviseMetadata = false;
                self.numberings = data.numberings;
                self.numbering = data.numbering;
                self.numberingLabel = data.numberingLabel;
                self.noteCode1997s = data.noteCode1997s;
                self.noteCode1997 = data.noteCode1997;
                self.noteCode1997Label = data.noteCode1997Label;
                self.noteCodeGPA113s = data.noteCodeGPA113s;
                self.noteCodeGPA113 = data.noteCodeGPA113;
                self.noteCodeGPA113Label = data.noteCodeGPA113Label;
                self.furtherCharacterizations = data.furtherCharacterizations;
                self.furtherCharacterization = data.furtherCharacterization;
                self.furtherCharacterizationLabel = data.furtherCharacterizationLabel;

                self.loading = false;

                if (self.useModal) {
                    self.showModal = true;
                }
            });
        },
        discard() {
            const self = this;

            self.id = 0;
            self.referenceNumber = null;
            self.excluded = false;
            self.definesSymbol = null;            
            self.textEn = null;
            self.textEs = null;
            self.textFr = null;
            self.displayOrder = 0;
            self.classificationSystem = null;
            self.inclusionClassificationSystemInfos = [];
            self.exclusionClassificationSystemInfos = [];
            self.reviseClassificationSystem = false;
            self.reviseMetadata = false;
            self.numbering = null;
            self.noteCode1997 = null;
            self.noteCodeGPA113 = null;
            self.furtherCharacterization = null;

            self.showModal = false;
        },
        save() {
            const self = this;

            let classificationSystemInfos = [];

            if (self.inclusionClassificationSystemInfos != null && self.inclusionClassificationSystemInfos.length > 0) {
                self.inclusionClassificationSystemInfos.forEach(value => {
                    classificationSystemInfos.push(value);
                });
            }

            if (self.exclusionClassificationSystemInfos != null && self.exclusionClassificationSystemInfos.length > 0) {
                self.exclusionClassificationSystemInfos.forEach(value => {
                    classificationSystemInfos.push({
                        id: value.id,
                        name: value.name,
                        code: value.code,
                        selected: false,
                        exclusion: true,
                        classificationHierarchyIds: value.classificationHierarchyIds
                    });
                });
            }

            let metadatas = []

            if (self.reviseMetadata) {
                if (self.numbering != null && self.numbering > 0) {
                    metadatas.push(self.numbering);
                }

                if (self.noteCode1997 != null && self.noteCode1997 > 0) {
                    metadatas.push(self.noteCode1997);
                }

                if (self.noteCodeGPA113 != null && self.noteCodeGPA113 > 0) {
                    metadatas.push(self.noteCodeGPA113);
                }

                if (self.noteCodeGPA113 != null && self.noteCodeGPA113 > 0) {
                    metadatas.push(self.noteCodeGPA113);
                }

                if (self.furtherCharacterization != null && self.furtherCharacterization > 0) {
                    metadatas.push(self.furtherCharacterization);
                }
            }

            self.$services.goods.save({
                id: self.id,
                referenceNumber: self.referenceNumber,
                excluded: self.excluded,
                definesSymbol: self.definesSymbol,
                classificationSystem: self.classificationSystem,
                textEn: self.textEn,
                textEs: self.textEs,
                textFr: self.textFr,
                footerEn: self.footerEn,
                footerEs: self.footerEs,
                footerFr: self.footerFr,
                displayOrder: self.displayOrder,
                reviseClassificationSystem: self.reviseClassificationSystem,
                classificationSystemInfos: classificationSystemInfos,
                reviseMetadata: self.reviseMetadata,
                metadataIds: metadatas
            }).then((data) => {
                if (data) {
                    self.counter += 1;
                    self.currentId = self.id + '|1|' + self.counter;

                    self.$emit('update:contextId', self.currentId);

                    self.$buefy.snackbar.open(`The goods was successfully stored`);

                    self.id = 0;
                    self.referenceNumber = null;
                    self.excluded = false;
                    self.definesSymbol = null;
                    self.textEn = null;
                    self.textEs = null;
                    self.textFr = null;
                    self.displayOrder = 0;
                    self.classificationSystem = null;
                    self.inclusionClassificationSystemInfos = [];
                    self.exclusionClassificationSystemInfos = [];
                    self.reviseClassificationSystem = false;
                    self.reviseMetadata = false;
                    self.numbering = null;
                    self.noteCode1997 = null;
                    self.noteCodeGPA113 = null;
                    self.furtherCharacterization = null;
                }
                else {
                    self.$buefy.snackbar.open(`The goods was not stored`);
                }

                if (self.useModal) {
                    self.showModal = false;
                }
            });
        }
    },    
    watch: {
        reviseClassificationSystem: function (value) {
            const self = this;

            if (value) {
                self.classificationSystem = self.retrievedClassificationSystem;
                self.inclusionClassificationSystemInfos = self.retrievedInclusionClassificationSystemInfos;
                self.exclusionClassificationSystemInfos = self.retrievedExclusionClassificationSystemInfos;

                if (self.annexNumbers.length <= 0) {
                    for (let index = 0; index <= 8; index++) {                        
                        self.annexNumbers.push({
                            value: index > 0 ? index : null,
                            text: index > 0 ? `Annex ${index}` : 'Not applicable'
                        });
                    }
                }
            }
            else {
                self.classificationSystem = null;
                self.inclusionClassificationSystemInfos = [];
                self.exclusionClassificationSystemInfos = [];
            }
        }
    },
    computed: {
        dataManagementBasicInformationLabel: function () {
            return window.labels.dataManagementBasicInformation;
        },
        dataManagementBasicInfoReferenceNumberLabel: function () {
            return window.labels.dataManagementBasicInfoReferenceNumber;
        },
        dataManagementBasicInfoDisplayOrderLabel: function () {
            return window.labels.dataManagementBasicInfoDisplayOrder;
        },
        dataManagementBasicInfoReviseClassificationSystemLabel: function () {
            return window.labels.dataManagementBasicInfoReviseClassificationSystem;
        },
        dataManagementBasicInfoReviseMetadataLabel: function () {
            return window.labels.dataManagementBasicInfoReviseMetadata;
        },
        dataManagementBasicInfoReviseMetadataLabel: function () {
            return window.labels.dataManagementBasicInfoReviseMetadata;
        },
        dataManagementClassificationSystemLabel: function () {
            return window.labels.dataManagementClassificationSystem;
        },
        dataManagementNoteReferenceAnnexNumberLabel: function () {
            return window.labels.dataManagementNoteReferenceAnnexNumber;
        },
        dataManagementExclusionLabel: function () {
            return window.labels.dataManagementExclusion;
        },
        dataManagementExcludedLabel: function () {
            return window.labels.dataManagementExcluded;
        },
        dataManagementInclusionLabel: function () {
            return window.labels.dataManagementInclusion;
        },
        dataManagementMetadataLabel: function () {
            return window.labels.dataManagementMetadata;
        },
        dataManagementSaveLabel: function () {
            return window.labels.dataManagementSave;
        },
        dataManagementCancelLabel: function () {
            return window.labels.dataManagementCancel;
        },        
        dataManagementAnnexNumberPlaceholderLabel: function () {
            return window.labels.dataManagementAnnexNumberPlaceholder;
        },
        dataManagementAnnex4TextLabel: function () {
            return window.labels.dataManagementAnnex4Text;
        },
        dataManagementAnnex4Label: function () {
            return window.labels.dataManagementAnnex4;
        }
    },
    template: `
        <div>
            <b-modal full-screen id="goodFormModal" ref="goodFormModal" :canCancel="false" v-model="showModal">
                <div class="modal-card" style="overflow-y: auto;">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{dataManagementAnnex4Label}}</b></p>
                        <button type="button" class="delete" @click="discard"/>
                    </header>
                    <section class="modal-card-body">
                        <div class="card">
			                <div class="card-content">                            
				                <template v-if="loading"><loading></loading></template>
				                <template v-else>
					                <div class="content">
                                        <fieldset class="box">
                                            <legend class="label has-text-centered section-legend">{{dataManagementBasicInformationLabel}}</legend>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field :label="dataManagementBasicInfoReferenceNumberLabel">
									                    <b-input v-model="referenceNumber"></b-input>
								                    </b-field>
                                                </div>
                                                <div class="column">
                                                    <b-field :label="dataManagementBasicInfoDisplayOrderLabel">
									                    <b-numberinput v-model="displayOrder"></b-numberinput>
								                    </b-field>
                                                </div>
                                            </div>
                                            <div class="columns">                                                                                        
                                                <div class="column">
                                                    <toggle-switch :values="languages" :selected.sync="language" default="en"></toggle-switch>
                                                </div>
                                                <div class="column">
                                                    <b-field :label="dataManagementExcludedLabel">
									                    <b-checkbox v-model="excluded"></b-checkbox>
								                    </b-field>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field :label="dataManagementAnnex4TextLabel">
													    <b-input v-model="textEn" v-if="language == 'en'"></b-input>
													    <b-input v-model="textFr" v-if="language == 'fr'"></b-input>
													    <b-input v-model="textEs" v-if="language == 'es'"></b-input>
												    </b-field>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <div class="columns">
                                            <div class="column">
                                                <b-field :label="dataManagementBasicInfoReviseClassificationSystemLabel">
													<b-checkbox v-model="reviseClassificationSystem"></b-checkbox>
												</b-field>
                                            </div>
                                            <div class="column">
                                                <b-field :label="dataManagementBasicInfoReviseMetadataLabel">
													<b-checkbox v-model="reviseMetadata"></b-checkbox>
												</b-field>
                                            </div>
                                        </div>
                                        <fieldset class="box" v-if="reviseClassificationSystem">
                                            <legend class="label has-text-centered section-legend">{{dataManagementClassificationSystemLabel}}</legend>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-tabs v-model="activeTab">
                                                        <b-tab-item :label="dataManagementInclusionLabel" value="0">
                                                            <div class="columns" v-for="classificationSystemInfo in inclusionClassificationSystemInfos" :key="classificationSystemInfo.id">
										                        <div class="column is-1">
                                                                    <b-field>
                                                                        <b-checkbox v-model="classificationSystemInfo.selected"></b-checkbox>
                                                                    </b-field>
										                        </div>
										                        <div class="column is-7">
                                                                    <b-field :label="classificationSystemInfo.displayCode" label-position="on-border">
                                                                        <classification-system-items-treeview-select :value.sync="classificationSystemInfo.classificationHierarchyIds" :classification-system-id="classificationSystemInfo.id" :placeholder="'Select ' + classificationSystemInfo.displayCode + ' classification code here'" :language="currentLanguage" guid="'inclusion_' + classificationSystemInfo.code +'_' + classificationSystemInfo.id"></classification-system-items-treeview-select>
                                                                    </b-field>
										                        </div>
                                                                <div class="column is-4">
                                                                    <b-field :label="dataManagementNoteReferenceAnnexNumberLabel" label-position="on-border">
                                                                        <b-select v-model="classificationSystemInfo.noteReferenceAnnexNumber" :placeholder="dataManagementAnnexNumberPlaceholderLabel" expanded>
                                                                            <option v-for="annexNumber in annexNumbers"
                                                                                :value="annexNumber.value"
                                                                                :key="classificationSystemInfo.id + '_' + annexNumber.value"> {{ annexNumber.text }}</option>
                                                                        </b-select>
                                                                    </b-field>
										                        </div>
									                        </div>
                                                        </b-tab-item>
                                                        <b-tab-item :label="dataManagementExclusionLabel"  value="1">
                                                            <div class="columns" v-for="classificationSystemInfo in exclusionClassificationSystemInfos" :key="classificationSystemInfo.id">
										                        <div class="column">
                                                                    <b-field :label="classificationSystemInfo.displayCode" label-position="on-border">
                                                                        <classification-system-items-treeview-select :value.sync="classificationSystemInfo.classificationHierarchyIds" :classification-system-id="classificationSystemInfo.id" :placeholder="'Select ' + classificationSystemInfo.displayCode + ' classification code here'" :language="currentLanguage" guid="'exclusion_' + classificationSystemInfo.code +'_' + classificationSystemInfo.id"></classification-system-items-treeview-select>
                                                                    </b-field>
										                        </div>
									                        </div>
                                                        </b-tab-item>
                                                    </b-tabs>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <fieldset class="box" v-if="reviseMetadata">
                                            <legend class="label has-text-centered section-legend">{{dataManagementMetadataLabel}}</legend>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field class="mb-0 p-0 metadata-control" :label="numberingLabel">
						                                <b-select v-model="numbering">
							                                <option
								                                v-for="option in numberings"
								                                :value="option.id"
								                                :key="option.id">
								                                {{ option.name }}
							                                </option>
						                                </b-select>
					                                </b-field>
                                                </div>
                                                <div class="column">
                                                    <b-field class="mb-0 p-0 metadata-control" :label="noteCode1997Label">
						                                <b-select v-model="noteCode1997">
							                                <option
								                                v-for="option in noteCode1997s"
								                                :value="option.id"
								                                :key="option.id">
								                                {{ option.name }}
							                                </option>
						                                </b-select>
					                                </b-field>
                                                </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <b-field class="mb-0 p-0 metadata-control" :label="noteCodeGPA113Label">
						                                <b-select v-model="noteCodeGPA113">
							                                <option
								                                v-for="option in noteCodeGPA113s"
								                                :value="option.id"
								                                :key="option.id">
								                                {{ option.name }}
							                                </option>
						                                </b-select>
					                                </b-field>
                                                </div>
                                                <div class="column">
                                                    <b-field class="mb-0 p-0 metadata-control" :label="furtherCharacterizationLabel">
						                                <b-select v-model="furtherCharacterization">
							                                <option
								                                v-for="option in furtherCharacterizations"
								                                :value="option.id"
								                                :key="option.id">
								                                {{ option.name }}
							                                </option>
						                                </b-select>
					                                </b-field>
                                                </div>
                                            </div>                                            
                                        </fieldset>
					                </div>
				                </template>
			                </div>
		                </div>                    
                    </section>
                    <footer class="modal-card-foot buttons">
					    <button type="button" class="button is-primary" @click="save">{{dataManagementSaveLabel}}</button>
					    <button type="button" class="button is-danger" @click="discard">{{dataManagementCancelLabel}}</button>
                    </footer>
                </div>
            </b-modal>            
        </div>        		            
	`
});